import React from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import { PaneLayout, SubmitButton } from '@app/core';
import { InformationHeader } from '@app/core';
import { useTranslation } from 'react-i18next';

const useStyles = createUseStyles((theme: Theme) => ({
  button: {
    width: '100%',
  },
}));

interface Props {
  icon: string;
  title: string;
  children: React.ReactNode;
  buttonDisabled?: boolean;
  noForm?: boolean;
}

export const InformationPaneLayout = ({
  icon,
  title,
  children,
  buttonDisabled,
  noForm,
}: Props) => {
  const { t } = useTranslation();
  const classes = useStyles();
  return (
    <PaneLayout
      noForm={noForm}
      submitSectionContent={
        <SubmitButton
          color="green"
          className={classes.button}
          text={t('form.button.submit')}
          disabled={buttonDisabled}
        />
      }
    >
      <InformationHeader icon={icon} title={title} to="/profile" />
      {children}
    </PaneLayout>
  );
};
